import { createContext } from 'react';

export interface InstanceIdContextType {
  instanceId: string;
}

export const InstanceIdContext = createContext<InstanceIdContextType | undefined>(undefined);